/**
 * Preserve UTM and referrer info across the checkout session.
 * Persists in sessionStorage to survive same-tab navigation.
 */
const KEY = "zppay.utm.v1";

export interface UTMs {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  referrer?: string;
  app_language?: string;
}

export function captureAndGetUTMs(): UTMs {
  const params = new URLSearchParams(window.location.search);
  const fromUrl: UTMs = {};
  for (const k of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "app_language"] as const) {
    const v = params.get(k);
    if (v) fromUrl[k] = v;
  }
  if (document.referrer && !fromUrl.referrer) fromUrl.referrer = document.referrer;
  const existing = readStored();
  const merged: UTMs = { ...existing, ...fromUrl };
  try {
    sessionStorage.setItem(KEY, JSON.stringify(merged));
  } catch {
    // Storage may be disabled (incognito + 3rd-party); fall back to in-memory.
  }
  return merged;
}

function readStored(): UTMs {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as UTMs) : {};
  } catch {
    return {};
  }
}
